module.exports = __webpack_public_path__ + "19c17d977cf7e6e1bf7e2b968585c4d2.MP3";